(function(){
'use strict';

angular.module('classy.frs').run(['$templateCache', function ($templateCache) {
  $templateCache.put('frs/shared/views', '<div ui-view="header"></div>\n' + '<div ui-view="body" class="public-page"></div>\n' + '<div ui-view="footer"></div>\n' + '<div sc-mobile-menu></div>\n' + '\n' + '<style data-ng-bind="theme.styles.css"></style>');
}]);
})();